export class Property {
	id: number;
  name: string;
  retailerLocations: any[] = [];
  polygon: any;
  position: any;
  description: any;
  addressText: any;
  sourceId: any;
  globalId: any;
  spaceCount: any;
  grossLeasableArea: any;
  geom: any;
  inhibitFork: boolean = false;
  applyToCapsuleRecord: boolean;
  approvedForPublicView: boolean;
  ready_: boolean = true;
  ownerProfileId: any;
}



// WEBPACK FOOTER //
// ./src/app/modules/maps-add-stuff/classes/property.ts